import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract'
import { sortByMultiField } from '@/utils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import {
  ensureExecuteSuccess,
  multiply,
  mergeArray,
  dateCompare, dateCompareYMD
} from '@/utils/commonUtil'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { AutoContaninerFactory } from '@/class/cargo/model/utils/AutoContaninerFactory'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import { getWarehouseDetail } from '@/api/company'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import $store from '@/store'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { CHARGE_SOURCE_SPLIT } from '@/class/cargo/model/parameters/SystemConstants'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'

export class TabInternationalCardBasePM extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.billChargeFlag = false // 费用是否做过账单
  }
  get salesOfficeCheck() {
    return this.view.salesOfficeCheck
  }
  set salesOfficeCheck(salesOfficeCheck) {
    this.view.salesOfficeCheck = salesOfficeCheck
  }
  get branchOfficeCheck() {
    return this.view.branchOfficeCheck
  }
  set branchOfficeCheck(branchOfficeCheck) {
    this.view.branchOfficeCheck = branchOfficeCheck
  }
  get creditOpen() {
    return this.view.creditOpen
  }
  set creditOpen(creditOpen) {
    this.view.creditOpen = creditOpen
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  init() {
    this.chargeWeightCalculationMode = ChargeUtils.getChargeWeightValueType(true)
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    this.customerLockInCargoSource = Number(this.config.get('CustomerLockInCargoSource')) === 1
    this.sEUseDischargingPort5Code = Number(this.config.get('SEUseDischargingPort5Code')) === 1
    this.refSelDesignationAgent = Number(this.config.get('refSelDesignationAgent')) === 1
    this.canChangeSalesOfJob = Number(this.config.get('canChangeSalesOfJob')) === 1
    this.isJoinCarrierBookingAgent = Number(this.config.get('CarrierBookingAgentJoin')) === 1
    this.isJoinPortDestinationAgent = Number(this.config.get('PortDestinationAgentJoin')) === 1
    this.ownerCompanyId = 0
  }
  changeJob() {
    if (this.job.uuid) {
      this.loadForBookingResultHandler()
      this.loadPushHistoryLogsHandler()
    } else {
      this.loadForBookingResultHandler()
    }
  }
  loadForBookingResultHandler() {
    this.loadWarehouseCmp()
    this.loadTrucking2()
    this.loadWarehouseInDetails()
  }
  /**
   * 加载job仓库信息
   */
  loadWarehouseCmp() {
    const job = this.job
    if (job.warehouseInfo != null && job.warehouseInfo.length > 0) {
      job.warehouseCmp = job.warehouseInfo[0].warehouseCmp
    } else {
      job.warehouseCmp = 0
    }
  }
  /**
   * 加载job运输公司
   */
  loadTrucking2() {
    const job = this.job
    if (job.trucking && job.trucking.length > 0) {
      // 需要排序，因为业务调整更新的 TruckingId desc排序后的第一条，要及时反馈出来
      sortByMultiField(job.trucking, ['truckingId'], true)
      job.carryingCmp = job.trucking[0].carryingCmp
    } else {
      job.carryingCmp = 0
    }
  }
  /**
   *  加载货物明细
   */
  loadWarehouseInDetails() {
    const job = this.job
    if (job.warehouseIn && job.warehouseIn.length > 0) {
      this.view.txtWhs = JobUtils.getWarehouseInDetail(job.warehouseIn)
    } else {
      this.view.txtWhs = ''
    }
  }
  loadPushHistoryLogsHandler() {
    AutoContaninerFactory.getInstance().job = this.job
    const fields = [
      {
        fieldName: this.view.$t('SeaExport.ActualQuantity'),
        key: 'quantityActual'
      }, {
        fieldName: this.view.$t('CargoMsg.Cargo_ActualWeight'),
        key: 'weightActual'
      }, {
        fieldName: this.view.$t('SeaExport.ActualVolume'),
        key: 'cubageActual'
      }
    ]
    fields.forEach(item => {
      ensureExecuteSuccess(() => this.view.$refs[item.key]).then(() => {
        const el = this.view.$refs[item.key].$el
        const className = 'input-blue'
        if (DataPushCompareUtils.comparePushData(item.fieldName, String(this.view.form[item.key]), this.job[item.key])) {
          if (!el.classList.contains(className)) {
            el.classList.add(className)
          }
        } else {
          if (el.classList.contains(className)) {
            el.classList.remove(className)
          }
        }
      })
    })
  }
  async fillView() {
    const job = this.job
    if (!job.uuid) {
      await this.loadOverseaAgentDetail()
      if (this.view.action === 'copy') {
        const notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + job.lob)
        JobUtils.doNotMatchAgainSelect(job, notMatchAgainSelect, { onlySales: true })
      }
      this.seaEqDateCl()
      JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, null, true)
    }
    this.loadCompanyOffice()
    this.ETDEditChange()
    if (!job.uuid && this.view.action === 'copy') {
      // 复制业务时校验新业务岗位角色在当前分公司是否有对应的岗位权限
      if (job.csr > 0) {
        this.view.$nextTick(() => {
          this.view.$refs.csr.executeAfterLoad(data => {
            if (JobUtils.checkUserRolePrivilege(data, job.csr)) {
              job.csr = 0
              job.csrDepartment = 0
            }
          })
        })
      }
      if (job.dc > 0) {
        this.view.$nextTick(() => {
          this.view.$refs.dc.executeAfterLoad(data => {
            if (JobUtils.checkUserRolePrivilege(data, job.dc)) {
              job.dc = 0
              job.dcDepartment = 0
            }
          })
        })
      }
      // 复制时带海外客服逻辑
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 指定货
        this.loadOverseaAgentUserByLob(job.designationAgent) // 指定货确定海外客服
      } else {
        this.loadOverseaAgentUserByLob(job.destinationAgent) // 目的港代理确定海外客服
      }
      this.setPlannerChange()
      this.checkCredit()
    }
    // 信控超期提醒
    this.sopConfig()
    this.loadOverseaOp()
  }
  /**
   * 加载指定货代理
   */
  async loadOverseaAgentDetail() {
    const job = this.job
    if (job.designationAgent > 0) {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      if (company) {
        await this.loadOverSeaResultHandler()
      }
    }
  }
  /**
   * 指定货代理，销售处显示网管名字。
   */
  async loadOverSeaResultHandler() {
    if (this.job.designationAgent > 0) {
      await this.loadOverseaAgentDetailOwner(this.job.designationAgent)
    }
  }
  /**
   * 指定货 -> 加载网管
   */
  async loadOverseaAgentDetailOwner(companyId) {
    this.ownerCompanyId = companyId
    const company = this.companyList.find(p => p.cmpIdx === companyId)
    if (company) {
      const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
      await this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
    }
  }
  async loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    const data = { value: 0 }
    if (overseaAgentDetail) {
      // 添加指定货代理等级
      const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
      if (overseaAgentGrade) {
        this.job.agentLevel = overseaAgentGrade.chineseName
      }
      const user = this.userList.find(p => p.userId === overseaAgentDetail.owner)
      if (user) {
        if (this.view.salesOfficeCheck) {
          if (user.active) {
            Object.assign(data, user)
            data.value = overseaAgentDetail.owner
          }
        } else {
          Object.assign(data, user)
          data.value = overseaAgentDetail.owner
        }
      }
    }
    await this.salesChangeHandler(data)
  }
  /**
   * 箱型信息控制
   */
  seaEqDateCl() {
    const job = this.job
    if (!job) return
    let eq = null
    if (job.containerLoadType === ContainerLoadType.STUFFY_TT.code) {
      if (job.seaEQ.length === 0) {
        eq = new SeaEQ().fillDefaultValue().getData()
        eq.eqType = 'HC'
        eq.eqSize = '40'
        eq.eqQuantity = 1
        eq.jobUuid = job.uuid
        job.seaEQ.push(eq)
        ContainerUtil.autoRefreshContainerUsages(job)
      }
    } else {
      job.seaEQ = []
      job.containerUsages = []
      job.containers = []
    }
  }
  /**
   * 包装选择
   */
  async txtPackingChangeHandler(event = null) {
    if (this.job.packing) {
      await new IntegratedJob(this.job).getContainerUsages()
      if (this.job.containerUsages && this.job.containerUsages.length > 0) {
        for (const item of this.job.containerUsages) {
          item.packing = this.job.packing
          item.isDirty = true
        }
      }
    }
  }
  loadCompanyOffice() {
    const job = this.job
    const office = this.context.officeList.filter(p => p.officeId === job.salesOffice)[0]
    if (office) {
      this.view.txtSalesOffice = office.chineseName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  // 计费重量修改
  async chargeWeightChange() {
    await this.changeSynBillOfLadingQWC()
  }
  ETDEditChange() {
    this.view.etdEnabled = this.view.isEdit
    if (this.job.actualUnBerthPlanDate) {
      const isChangeETD = (parseInt(this.config.get('isChangeETD')) === 1)
      if (isChangeETD) {
        this.view.etdEnabled = false
      }
    }
  }
  /**
   * 按业务指定海外客服
   */
  async loadOverseaAgentUserByLob(cmpIdx) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    const cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
    if (cmp) {
      const overseaAgentDetail = await new Company(cmp).getOverseaAgentDetail()
      this.loadDestinationAgentDetaiHandler(overseaAgentDetail)
    } else {
      if (this.view.$refs.overseaOp) {
        const firstOption = this.view.$refs.overseaOp.options[0]
        job.overseaOp = firstOption ? firstOption.userId : 0
        job.overseaOpDepartment = 0
      }
    }
  }
  async loadDestinationAgentDetaiHandler(agent) {
    if (this.view.isHC) {
      return
    }
    if (!agent) {
      const job = this.job
      const cmpIdx = job.cargoSource === CargoSource.NC_CARGO_SOURCE.code ? job.designationAgent : job.destinationAgent
      const company = this.companyList.find(p => p.cmpIdx === cmpIdx)
      if (company) {
        agent = await new Company(company).getOverseaAgentDetail()
      }
    }
    if (agent) {
      const overseaAgentUserList = await new OverseaAgent(agent).getOverseaAgentUserList()
      this.loadOverseaAgentUserHandler(overseaAgentUserList)
    }
  }
  loadOverseaAgentUserHandler(overseaAgentUsers) {
    // 海外客服
    const overseaAgentUsersList = []
    let overseaAgentUserDefaultId = 0
    if (overseaAgentUsers && overseaAgentUsers.length > 0) {
      for (const u of overseaAgentUsers) {
        if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaAgentUserDefaultId = u.userId
              }
              overseaAgentUsersList.push(user)
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaAgentUsersList = overseaAgentUsersList
    // 海外客服默认值
    if (overseaAgentUsersList.length > 0) {
      let overseaOp = 0
      if (overseaAgentUserDefaultId > 0) {
        overseaOp = overseaAgentUserDefaultId
      } else {
        overseaOp = overseaAgentUsersList[0].userId
      }
      let newUser = null
      if (overseaOp > 0) {
        newUser = this.userList.find(p => p.userId === overseaOp)
      }
      if (newUser && overseaOp !== this.job.overseaOp) {
        // 复制时判断
        if (this.view.action === 'copy') {
          const overseaUser = this.userList.find(p => p.userId === this.job.overseaOp)
          const oldOverseaUser = !overseaUser ? '' : !overseaUser.chineseName ? overseaUser.englishName : overseaUser.chineseName// 原业务 海外客服
          const newOverseaUser = !newUser ? '' : !newUser.chineseName ? newUser.englishName : newUser.chineseName// 新 海外客服
          if (overseaUser && this.isActiveOverSeaOp() && overseaAgentUsersList.find(p => p.userId === overseaUser.userId)) {
            overseaOp = this.job.overseaOp
          } else {
            let msg = this.view.$t('SeaExport.OverseaCustomerUpdate')
            msg = msg.replace('{0}', oldOverseaUser)
            msg = msg.replace('{1}', newOverseaUser)
            this.view.$confirm(msg, this.view.$t('Message.Prompt'), {
              confirmButtonText: this.view.$t('common.btn.ok'),
              cancelButtonText: this.view.$t('common.btn.cancel'),
              type: 'warning'
            }).then(() => {
              this.job.overseaOp = overseaOp
            }).catch(() => {
              this.job.overseaOp = 0
            }).finally(() => {
              this.overseaOpChangeHandler()
            })
          }
        } else {
          this.job.overseaOp = overseaOp
          this.overseaOpChangeHandler()
        }
      }
    } else {
      this.job.overseaOp = 0
      this.job.overseaOpDepartment = 0
    }
  }
  /**
   * 判断海外客服是否有效
   */
  isActiveOverSeaOp() {
    const job = this.job
    let flag = false
    if (job && job.overseaOp) {
      const user = this.userList.find(p => p.userId === job.overseaOp)
      if (user && user.active) {
        flag = true
      }
    }
    return flag
  }
  /**
   * 卸货港选择
   */
  async dischargingPortCodeChange(evt) {
    const job = this.job
    job.destinationPortCode = evt
    job.dischargingPortCode = evt
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const selPort = seaPorts.filter(p => p.code === job.dischargingPortCode)
    if (selPort && selPort.length > 0) {
      job.destinationPlace = selPort[0].englishName
    }
    await JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }))
  }
  /**
   * 船公司选择
   */
  carrierFocusOutEventHandler(carrierId) {
    if (this.carrierIdIsDirty) {
      this.refreshBookingAgentAutoComplete().then(r => {})
      this.carrierIdIsDirty = false
    }
  }
  /**
   * 船公司要与订舱代理进行关联
   */
  async refreshBookingAgentAutoComplete() {
    const job = this.job
    const company = await Company.getCompanyById(job.carrierId)
    if (company) {
      await company.getBookingAgentList(true, false)
      const dataArray = []
      for (const bookingAgentCarrier of company.bookingAgentList) {
        dataArray.push(bookingAgentCarrier.bookingAgent)
      }
      this.bookingAgentArray = dataArray
    }
    job.bookingAgent = 0
  }
  // 设置路线负责人
  setPlannerChange() {
    if (this.view.isEdit) {
      const job = this.job
      const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
      if (port) {
        const region = this.regionList.find(p => p.code === port.region)
        if (region && region.plannerList) {
          const pList = region.plannerList.split(',')
          let p = 0
          for (const u of pList) {
            const t = u.split('-')
            if (t.length === 2 && (t[0] === 'SE' || t[0] === 'ALL')) {
              p = Number(t[1]) || 0
            } else {
              p = Number(t[0]) || 0
            }
            if (p) {
              break
            }
          }
          if (p > 0) {
            job.planner = p
          }
        }
      }
    }
  }
  /**
   * 投保成功
   */
  insureSuccessHandler(data) {
    const result = data.result
    const status = data.status
    if (status === 'true') {
      window.open(result, '_blank', 'noreferrer')
    } else {
      this.view.$message.warning(result)
    }
  }

  containerLoadTypeChange(containerLoadType) {
    const job = this.job
    this.view.$confirm(this.view.$t('Message.OrderTypeChangeTip'), this.view.$t('Message.Confirm'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      // CARGO-49764 CL 整车/零担 和 IC 国际卡航 转变成 集卡拖车的时候 预计到货日和实际到货日 门点里面清空了 但是显示列还有
      if (job.containerLoadType !== ContainerLoadType.STUFFY_TT.code && containerLoadType === ContainerLoadType.STUFFY_TT.code) {
        if (job.trucking && job.trucking.length > 0) {
          job.trucking.forEach((truck) => {
            if (truck.integratedTruckingInfo) {
              // 置空 actualArrivalDate 和 arriveDate
              truck.integratedTruckingInfo.actualArrivalDate = ''
              truck.integratedTruckingInfo.arriveDate = ''
            }
          })
        }
      }
      job.containerLoadType = containerLoadType
      // CARGO-40378【当切换【综合物流订单类型】时，会提示清空数据，对应清空已选择的【自定义业务类型】值
      this.job.customJobType = ''
      this.seaEqDateCl()
      if (job.containerLoadType === ContainerLoadType.STUFFY_TT.code) {
        job.truckingInfoType = 0
        job.operateType = ''
      } else if (job.containerLoadType === ContainerLoadType.STUFFY_IC.code) {
        job.truckingInfoType = 2
        if (!job.operateType) {
          job.operateType = ContainerLoadType.DIRECT.code
        }
      } else {
        job.truckingInfoType = 1
        job.operateType = ''
      }
      job.landTransportation = true
      job.warehousing = job.selfDeliver = false
      // this.selectDefaultCutomJobType()
      this.view.customJobTypeList = JobUtils.setCustomJobTypeList(job.lob, job.containerLoadType, job.fba)
      this.view.$emit('containerLoadTypeEvent', containerLoadType)
    })
  }
  operateTypeChange(operateType) {
    this.job.operateType = operateType
  }
  /**
   * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
   */
  selectDefaultCutomJobType() {
    const cutomJobTypeList = getCacheListByKey(basicCacheKeys.basic_data_CutomJobType)
    const options = cutomJobTypeList.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
  }
  /**
   * 揽货类型选择
   */
  async cargoSourceChange(event) {
    const job = this.job
    this.loadDestinationAgentDetaiHandler()
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      job.sales = 0
      job.salesOffice = 0
      job.salesDepartment = 0
      this.view.txtSalesOffice = ''
      this.view.salesList = null
      this.loadOverseaAgentDetailOwner(job.designationAgent)
    } else {
      job.designationAgent = 0
      this.customerIdChangeNew(event)
    }
    this.loadCustomerPortDestinationAgents()
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      this.loadOverseaAgentUserByLob(job.designationAgent) // 根据指定货确定海外客服
    } else {
      this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
      this.checkNewJobCreditInfo()
    }
  }
  /**
   * 委托单位选择（从写委托单位选择，去掉当前与分公司校验）
   */
  customerIdChangeNew(event) {
    const job = this.job
    job.editCftMode = false
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      // CARGO-1986 淳宏：合伙伙伴中同时勾选指定货和自拦货时，新增业务时揽货类型，无法选择
      this.loadCustomerDetail(event)// 联系人或者揽货类型
      this.showCustomerDetail()// 客户级别
      this.loadCustomerPortDestinationAgents()
      this.loadCompanyUser()// 销售
      if (company.mustInputScn) {
        job.editCftMode = true
      }
    } else {
      job.customerId = 0
      if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        this.view.txtSalesOffice = ''
        job.sales = 0 // 销售
        job.dc = 0 // 单证
        job.csr = 0 // 客服
      }
      this.getTxtSalesPrompt()
    }
  }
  /**
   * 加载客户信息
   */
  async loadCustomerDetail(event) {
    const job = this.job
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      this.view.contactList = await Company.loadContact(company.uuid)
      this.onCustomerContactLoad()
      this.onCustomerDetailLoad(event)
    }
  }
  onCustomerContactLoad() {
    let linkMan = ''
    if (this.view.contactList && this.view.contactList.length > 0) {
      var contact = this.getDefaultContact(this.view.contactList)
      if (contact) {
        linkMan = contact.contactPerson
      }
    }
    if (this.view.isEdit) {
      this.view.form.customerContact = linkMan
    }
  }
  /**
   * 获取默认联系人
   */
  getDefaultContact(ary) {
    let rs = null
    if (ary && ary.length > 0) {
      rs = ary[0]
      for (const contact of ary) {
        if (contact.defaultContact) {
          rs = contact
          break
        }
      }
    }
    return rs
  }
  async onCustomerDetailLoad(event) {
    const job = this.job
    const customer = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (!customer || !customer.uuid) {
      return
    }
    const customerDetail = await Company.loadCustomer(customer.uuid).then(data => data.length > 0 ? data[0] : null)
    if (customer && customerDetail) {
      const oldCargoSource = job.cargoSource
      let newCargoSource = ''
      if (event && event.fieldName === 'cargoSource') {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        }
      } else if (customerDetail.designated && customerDetail.seftCanvass) {
        if (Number(this.config.get('CustomerDefaultCargoSource')) === 0) {
          newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        } else {
          newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        }
      } else {
        if (customerDetail.designated) {
          newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (customerDetail.seftCanvass) {
          newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        }
      }

      // CARGO-15204 输入委托单位后，揽货类型会从指定货变更为自揽货的错误
      if (oldCargoSource !== newCargoSource && newCargoSource) {
        const msg = newCargoSource === CargoSource.SC_CARGO_SOURCE.code ? this.view.$t('CargoMsg.Cargo_CustomerSpace3') : this.view.$t('CargoMsg.Cargo_CustomerSpace2')
        this.view.$confirm(this.view.$t('CargoMsg.Cargo_CargoSourceTip', [msg]), this.view.$t('common.tips.prompt'), {
          confirmButtonText: this.view.$t('common.btn.yes'),
          cancelButtonText: this.view.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          job.cargoSource = newCargoSource
          this.checkNewJobCreditInfo()
        }).catch(() => {
        })
      }
    }
  }
  /**
   * 自揽货 -> 加载销售(如果合作伙伴服务人员有多个则不刷新)
   */
  async loadCustomerDetailSales(companyId) {
    if (!this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === companyId)
      await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
      if (company && company.customerDetail) {
        const salseTemp = company.customerDetail.sales
        const user = this.userList.find(p => p.userId === salseTemp)
        if (user && user.active) {
          this.salesChangeHandler({ ...user, value: salseTemp })
        }
      } else {
        this.salesChangeHandler({ value: 0 })
      }
    }
  }
  /**
   * 加载客户类型
   */
  async showCustomerDetail() {
    const job = this.job
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      const customerDetail = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
      if (customerDetail) {
        this.lockInCargoSource(customerDetail)
      }
    }
  }
  /**
   * 是否锁定揽货类型
   */
  lockInCargoSource(customerDetail) {
    this.view.cargoSourceEnabled = this.view.isEdit
    if (!(customerDetail.designated && customerDetail.seftCanvass)) {
      if (customerDetail.designated || customerDetail.seftCanvass) {
        if (this.customerLockInCargoSource && this.view.isEdit) {
          this.view.cargoSourceEnabled = false
        }
      }
    }
  }
  async loadCustomerPortDestinationAgents(allowPopup = false) {
    if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
        this.loadCustomerDetail1Handler(company.customerDetail, allowPopup)
      }
    }
  }
  async loadCustomerDetail1Handler(customerDetail, allowPopup = false) {
    if (customerDetail) {
      const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
      this.loadPortDestinationAgentsHandler(portDestinationAgents, allowPopup)
    }
  }
  loadPortDestinationAgentsHandler(portDestinationAgents, allowPopup = false) {
    if (portDestinationAgents) {
      const job = this.job
      // 判断是否只维护了一个指定货代理且目的港为空,如果仅维护一个，则所有的目的港指定货代理取值维护的指定货代理
      let isOnlyPortDestinationAgent = false
      let defaultPortDestinationAgent = null
      if (portDestinationAgents && portDestinationAgents.length === 1) {
        defaultPortDestinationAgent = portDestinationAgents[0]
        if (!defaultPortDestinationAgent.destinationPort) {
          isOnlyPortDestinationAgent = true
        }
      }
      // 判断当前业务的指定货代理是否为空
      if (!job.designationAgent || Number(job.designationAgent) === 0) {
        if (portDestinationAgents.length === 1) {
          if (isOnlyPortDestinationAgent) {
            if (defaultPortDestinationAgent.defaultAgent) {
              this.updatePortDestinationAgentInformation(defaultPortDestinationAgent)
            }
          } else {
            if (job.dischargingPortCode === defaultPortDestinationAgent.destinationPort && defaultPortDestinationAgent.defaultAgent) {
              this.updatePortDestinationAgentInformation(defaultPortDestinationAgent)
            }
          }
        } else {
          // 现根据卸货港去匹配，匹配不到取默认指定货代理
          let isFind = false
          if (portDestinationAgents && portDestinationAgents.length > 0) {
            for (const a of portDestinationAgents) {
              if (job.dischargingPortCode === a.destinationPort && a.defaultAgent) {
                isFind = true
                this.updatePortDestinationAgentInformation(a)
                break
              }
            }
            // 取默认的指定货代理
            if (!isFind) {
              for (const b of portDestinationAgents) {
                if (!b.destinationPort && b.defaultAgent) {
                  this.updatePortDestinationAgentInformation(b)
                  break
                }
              }
            }
          }
        }
      } else {
        // 业务中有指定货代理，判断目的港是否维护有默认的指定货代理(默认的指定货代理只有一个)
        let i = 0
        let isDefaultAgent = false
        let defaultAgent = null
        if (portDestinationAgents && portDestinationAgents.length > 0) {
          for (const a1 of portDestinationAgents) {
            if (job.dischargingPortCode === a1.destinationPort) {
              i++
              if (a1.defaultAgent) {
                defaultAgent = a1
                isDefaultAgent = true
              }
            }
          }
        }
        if (portDestinationAgents && portDestinationAgents.length >= 2) {
          for (const a2 of portDestinationAgents) {
            if (!a2.destinationPort) {
              isOnlyPortDestinationAgent = true
            }
          }
        }
        if (i === 0 && job.dischargingPortCode && !isOnlyPortDestinationAgent) {
          const callback = () => {
            job.designationAgent = 0
            this.loadOverseaAgentDetailOwner(0)
            this.view.txtSalesOffice = ''
            job.sales = 0
            job.salesDepartment = 0
          }
          if (allowPopup) {
            this.view.$confirm(this.view.$t('SeaExport.UnloadingPortNotMaintain'), this.view.$t('common.tips.prompt'), {
              confirmButtonText: this.view.$t('common.btn.ok'),
              cancelButtonText: this.view.$t('common.btn.cancel'),
              type: 'warning'
            }).then(() => {
              callback()
            }).catch(() => { })
          } else {
            callback()
          }
        }

        if (job.dischargingPortCode) {
          if (isDefaultAgent) {
            if (job.designationAgent !== defaultAgent.destinationAgentId) {
              if (allowPopup) {
                this.view.$confirm(this.view.$t('SeaExport.PortMaintainedDesignatedFreightForwarder'), this.view.$t('common.tips.prompt'), {
                  confirmButtonText: this.view.$t('common.btn.ok'),
                  cancelButtonText: this.view.$t('common.btn.cancel'),
                  type: 'warning'
                }).then(() => {
                  this.updatePortDestinationAgentInformation(defaultAgent)
                }).catch(() => { })
              } else {
                this.updatePortDestinationAgentInformation(defaultAgent)
              }
            }
          } else {
            if (portDestinationAgents && portDestinationAgents.length > 0) {
              for (const c of portDestinationAgents) {
                if (!c.destinationPort && c.defaultAgent) {
                  this.updatePortDestinationAgentInformation(c)
                  break
                }
              }
            }
          }
        }
      }
    }
  }
  /**
   * 更新指定货代理以及销售栏位等信息
   */
  updatePortDestinationAgentInformation(agent) {
    const job = this.job
    job.designationAgent = agent.destinationAgentId
    // 指定货带网管
    this.loadOverseaAgentDetailOwner(job.designationAgent)
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
    } else {
      this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
    }
  }
  /**
   * 按业务指定销售
   */
  loadCompanyUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      }
    }
  }
  async loadCompanyUserHandler(companyUsers) {
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 客服
    const csrList = []
    let csrDefaultId = 0
    // 单证
    const dcList = []
    let dcDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 自定义岗位1
    const userDefinedRoleId1List = []
    let userDefinedRoleId1 = 0
    // 自定义岗位2
    const userDefinedRoleId2List = []
    let userDefinedRoleId2 = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId)
    }
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              csrList.push(user)
            } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
              if (u.defaultUser) {
                dcDefaultId = u.userId
              }
              dcList.push(user)
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
              if (u.defaultUser) {
                userDefinedRoleId1 = u.userId
              }
              userDefinedRoleId1List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
              if (u.defaultUser) {
                userDefinedRoleId2 = u.userId
              }
              userDefinedRoleId2List.push(user)
            }
          }
        }
      }
    }
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      // 销售
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        this.view.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.sales)
          this.salesChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.sales = 0
        // job.salesDepartment = 0
        // this.view.txtSalesOffice = ''
      }
    }
    // 客服
    if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
    }
    // 单证
    if (dcList.length > 0) {
      if (dcDefaultId > 0) {
        job.dc = dcDefaultId
      } else {
        job.dc = dcList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.dc = 0
      // job.dcDepartment = 0
    }
    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        this.cargoSalesChargeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.txtOPChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          this.overseaOpChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
    // 自定义岗位1
    if (userDefinedRoleId1List.length > 0) {
      job.userDefinedRoleId1 = userDefinedRoleId1 > 0 ? userDefinedRoleId1 : userDefinedRoleId1List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId1)
        this.userDefinedRoleId1Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId1 = 0
      // job.userDefinedRoleDept1 = 0
      // job.userDefinedRoleOffice1 = 0
    }
    // 自定义岗位2
    if (userDefinedRoleId2List.length > 0) {
      job.userDefinedRoleId2 = userDefinedRoleId2 > 0 ? userDefinedRoleId2 : userDefinedRoleId2List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId2)
        this.userDefinedRoleId2Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId2 = 0
      // job.userDefinedRoleDept2 = 0
      // job.userDefinedRoleOffice2 = 0
    }
  }
  getTxtSalesPrompt() {
    if ((Number(this.config.get('IsSpecifiedSalesBusiness')) === 1) && (this.view.$refs.sales.options.length === 0)) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      this.view.salesPrompt = ''
    }
  }
  sopChangeCustomerIdHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.customerId) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectTheEntrustingCompany'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.customerId, 'customer').then(data => {
      this.pageBResultHandler(data)
    })
  }
  pageBResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.customerId, 'customer')
  }
  pageResultHandler(contactList, cmpIdx, agent) {
    this.view.sopDialog.cmpIdx = cmpIdx
    this.view.sopDialog.agent = agent
    this.view.sopDialog.contactList = contactList
    this.view.sopDialog.resultFunction = value => {
      this.saveSop(value, agent)
    }
    this.view.sopDialog.visible = true
  }
  saveSop(value, agent) {
    if (agent) {
      const job = this.job
      switch (agent) {
        case 'customer':
          job.ifPushSop = value
          break
        case 'DestinationAgent':
          job.ifPushSopM = value
          break
        case 'DesignationAgent':
          job.ifPushSopZ = value
          break
        case 'PortOfLoadingAgent':
          job.ifPushSopQ = value
          break
      }
    }
  }
  /**
   * 指定货代理选择
   */
  designationAgentChangeHandler(data) {
    const job = this.job
    job.designationAgent = data.value || 0
    this.view.showWarningImageA = false
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 2)
      this.checkNewJobCreditInfo()
    } else {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      if (this.view.sopConfigOpen && company) {
        // 判断该合作伙伴是否开启SOP
        this.view.sopImageA = company.ifOpenSop
      }
    }
    if (job.designationAgent > 0) {
      this.loadOverseaAgentDetail()
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
      }
    } else {
      if (!this.view.isHC) {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          job.overseaOp = 0
          job.overseaOpDepartment = 0
          this.view.overseaAgentUsersList = []
        }
      }
    }
  }
  /**
   * 本地服务选择
   */
  loadingTermChange(fieldName) {
    const job = this.job
    if (fieldName === 'warehousing') {
      if (!job.warehousing) {
        job.warehouseCmp = 0
        job.warehouseRecord = 0
        const warehouseInfo = job.warehouseInfo
        if (warehouseInfo && warehouseInfo.length > 0) {
          for (const item of warehouseInfo) {
            item.deleted = true
            this.removeWarehouseFromModifiedSet(item)
          }
          warehouseInfo.splice(0, warehouseInfo.length)
        }
      }
      this.view.$emit('resetTab', 'tabWarehouse')
    }
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    if (warehouse.uuid) {
      const removedData = this.context.removedData
      removedData.warehouseInfo = removedData.warehouseInfo || []
      removedData.warehouseInfo.push(warehouse)
    }
  }
  // 添加truckingInfo到被修改的集合中
  addTruckingToModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    modifiedData.truckingInfo = modifiedData.truckingInfo || []
    if (!modifiedData.truckingInfo.includes(truckingInfo)) {
      modifiedData.truckingInfo.push(truckingInfo)
    }
  }
  // 将truckingInfo从被修改的集合中移除
  removeTruckingFromModifiedSet(truckingInfo) {
    if (truckingInfo.uuid) {
      const removedData = this.context.removedData
      removedData.delTruckingInfoUuids = removedData.delTruckingInfoUuids || []
      removedData.delTruckingInfoUuids.push(truckingInfo.uuid)
    }
  }
  /**
   * 检查业务参考号是否存在
   */
  async customerRefNoFocusOutHandler() {
    const job = this.job
    if (!StrUtils.isEmpty(job.customerRefNo)) {
      job.customerRefNo = job.customerRefNo.trim()
      const checkJobFields = {}
      checkJobFields.customerRefNo = job.customerRefNo
      const fieldExistResult = await IntegratedJob.checkJobFieldExist(this.view.$store.getters.currentOfficeId, job.lob, checkJobFields, job.uuid)
      if (fieldExistResult.customerRefNo) {
        this.view.customerRefNoTip = this.view.$t('Message.BusinessReferenceNoReduplicated')
      } else {
        this.view.customerRefNoTip = ''
      }
    }
  }
  /**
   * 运输公司
   */
  carryingCmpChangeHandler(data) {
    const job = this.job
    job.carryingCmp = data.value
    if (job.trucking.length === 0) {
      const newData = new TruckingInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.trucking.push(newData)
    }
    const truckingInfo = job.trucking[0]
    truckingInfo.carryingCmp = job.carryingCmp
    if (job.carryingCmp === 0) {
      truckingInfo.driver = ''
      truckingInfo.driverTel = ''
    }
    this.addTruckingToModifiedSet(truckingInfo)
  }
  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    this.view.warehouseNameList = []
    if (job.warehouseCmp > 0) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.warehouseCmp)
      if (companyCache) {
        getWarehouseDetail(companyCache.uuid).then(res => {
          if (res.data.length > 0) {
            this.view.warehouseNameList = res.data
          }
        })
      }
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    job.warehouseName = warehouse.warehouseName
    this.addWarehouseToModifiedSet(warehouse)
  }
  /**
   * 当选择销售人员的时候自动关联该销售所在分公司
   */
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = office.chineseName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
            this.view.txtSalesOffice = office.chineseName
          }
        }
      }
    }
  }
  /**
   * 操作改变
   */
  txtOPChangeHandler(user) {
    const job = this.job
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      if (job.opOffice > 0) {
        new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      } else {
        new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      }
    }
  }
  /**
   * 客服改变
   */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          job.csrOffice = office ? office.officeId : 0
        }
      }
    }
  }
  // 现场操作
  async siteOpChangeHandler(data) {
    const job = this.job
    job.siteOP = data.value
    job.siteOpDepartment = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'siteOp', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            job.siteOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'siteOp')
        job.siteOpDepartment = dep ? dep.departmentId : 0
      }
    }
  }
  /**
   * 国外客服改变
   */
  async overseaOpChangeHandler(data) {
    if (data) {
      const dep = await new User(data).getDefaultDepartment('role', 'overseaOp')
      if (dep) {
        this.job.overseaOpDepartment = dep.departmentId
      }
    } else {
      this.job.overseaOpDepartment = 0
    }
  }
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'doc')
      job.dcDepartment = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.dcOffice = office ? office.officeId : 0
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }
  async truckCsrChangeHandler(data) {
    const job = this.job
    job.truckCsr = data.value
    job.truckDept = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'truckCsr')
      job.truckDept = dep ? dep.departmentId : 0
    } else {
      job.truckCsr = 0
      job.truckDept = 0
    }
  }
  /**
   * 路线改变
   */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'seaLine')
      job.plannerDepartment = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.plannerOffice = office ? office.officeId : 0
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }
  // 委托件毛体 更改事件 @change 事件中的 委托的 件毛体赋值 在此之后 导致 装箱数据仍是上一次的值
  async jobContractQwcChange(type) {
    if (type === 1) {
      await SEUtils.changeQWCRule(() => {
        this.job.quantityActual = this.job.quantityContract
      })
      this.changeSynBillOfLadingQWC()
    } else if (type === 2) {
      await SEUtils.changeQWCRule(async() => {
        if (this.job.weightActual !== this.job.weightContract) {
          this.job.weightActual = this.job.weightContract
          if (ChargeUtils.getChargeWeightValueType(true) === 0) {
            await this.refreshWeightCharge(this.job, this.job.weightActual)
          }
        }
      })
      await this.calculateChargeWeight()
    } else if (type === 3) {
      await SEUtils.changeQWCRule(async() => {
        if (this.job.cubageActual !== this.job.cubageContract) {
          this.job.cubageActual = this.job.cubageContract
          await this.refreshCubageCharge(this.job, this.job.cubageActual)
        }
        this.job.chargeWeight = this.job.cubageContract
      })
      await this.calculateChargeWeight()
    }

    this.refContainerUsageQwc(2, true)
  }
  async refreshWeightCharge(job, weight) {
    const charges = ChargeUtils.weightChargesCanUpdate(job)
    if (charges.length > 0) {
      await this.view.$confirm(this.view.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const charge of charges) {
          charge.quantity = weight
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          } else {
            ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          }
        }
        this.view.context.modifiedData.charges = this.view.context.modifiedData.charges || []
        mergeArray(this.view.context.modifiedData.charges, charges)
        this.view.context.reloadCharge = true
      }).catch(() => {})
    }
    ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.view.context)
  }
  async refreshCubageCharge(job, cubage) {
    const charges = await ChargeUtils.cubageChargesCanUpdate(job)
    if (charges.length > 0) {
      await this.view.$confirm(this.view.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const charge of charges) {
          charge.quantity = cubage
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          } else {
            ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          }
        }
        this.view.context.modifiedData.charges = this.view.context.modifiedData.charges || []
        mergeArray(this.view.context.modifiedData.charges, charges)
        this.view.context.reloadCharge = true
      }).catch(() => {})
    }
  }
  async changeSynBillOfLadingQWC() {
    await CargoDocUtil.changeSynBillOfLadingQWC(this.job, this.job.quantityActual, this.job.weightActual, this.job.cubageActual)
  }
  /**
   * 计费重量修改计算
   */
  async calculateChargeWeight() {
    try {
      let weight = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.weightContract) : parseFloat(this.job.weightActual)
      const cubage = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.cubageContract) : parseFloat(this.job.cubageActual)
      let chargeFlag = false
      if (isNaN(weight) || isNaN(cubage)) return
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      this.job.chargeWeight = parseFloat(weight.toFixed(3))
      for (const charge of this.job.charges) {
        if (!charge.confirmBillUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
          chargeFlag = true
          break
        }
      }
      if (chargeFlag) {
        this.view.$confirm(this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          for (const charge of this.job.charges) {
            if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
                !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
                !charge.verifiedAmount && !charge.paidOff) {
              charge.quantity = this.job.chargeWeight
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
            }
          }
        }).catch(() => {
        }).finally(() => {
        })
      }
      this.txtCubageActualFocusOutHandler(this.job.cubageActual)
      await this.changeSynBillOfLadingQWC()
    } catch (e) {
      // error
    }
  }
  refContainerUsageQwc(viewPager = 0, btnSave = true) {
    ContainerUtil.refContainerUsageQwc(this.job, viewPager, btnSave)
  }
  async fillModel() {
    const job = this.job
    if (job.shipperId && !job.shippeerCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.shipperId)
      if (cmp) {
        job.shipperCode = cmp.shortName
      }
    }
    if (job.consigneeId && !job.consigneeCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.consigneeId)
      if (cmp) {
        job.consigneeCode = cmp.shortName
      }
    }
    if (job.notifyId && !job.notifyCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.notifyId)
      if (cmp) {
        job.notifyCode = cmp.shortName
      }
    }
    // 仓库
    await this.getWarehouseInfo()
    // 车队
    await this.getTruckingInfo()
    const expression = parseInt(this.config.get('ContainerUpdateJobQCW'))
    if (expression === 3 && this.view.isTabContainerInfo && this.view.isEdit) {
      ContainerUtil.refContainerUsageQwc(job, 0, this.view.btnSave)
    }
    this.view.isTabContainerInfo = false
    this.view.btnSave = true
    // 同步报关行
    await JobUtils.synCustomsBroker(job, job.customsBroker)
  }

  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfo() {
    const job = this.job
    if (this.creditOpen && StrUtils.isEmpty(job.uuid)) {
      // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
      const checkResult = this.checkNewJobCreditInfoFunc(job)
      this.view.processingPromiseList.push(checkResult)
      try {
        await checkResult
      } finally {
        const index = this.view.processingPromiseList.indexOf(checkResult)
        if (index > -1) {
          this.view.processingPromiseList.splice(index, 1)
        }
      }
    }
  }

  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfoFunc(job) {
    const params = JobUtils.getCreditCheckJob(job)
    await canCreateByCreditInfoDetail(params).then(async res => {
      if (res.data > 0) {
        const msg = {
          dangerouslyUseHTMLString: true,
          message: await JobUtils.checkDateAndAmountExceeded(res.data),
          type: 'warning',
          duration: 5000
        }
        this.view.$message.warning(msg)
        job.customerId = 0
      }
    })
  }

  checkCredit() {
    this.view.showWarningImageA = false
    this.view.showWarningImageB = false
    if (this.view.creditOpen) {
      const job = this.job
      // 委托单位
      if (job && job.customerId > 0) {
        this.checkCreditByCompany(job.customerId, 1)
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 2)
      }
    }
  }

  sopConfig() {
    this.view.sopImageB = false
    SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
      this.configSuccessHandler(data.sopPushConfig)
    })
  }

  async configSuccessHandler(sop) {
    if (sop) {
      this.view.sopConfigOpen = sop.ifAuto
    }
  }

  /**
   * type代表不同的角色
   */
  checkCreditByCompany(companyId, type) {
    const callback = credit => {
      let checkCredit = false
      const company = this.context.companyList.find(p => p.cmpIdx === companyId)
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          if (credit.amountExceeded) { tip += this.view.$t('CargoMsg.Cargo_Limit') }
          if (credit.dateExceeded) { tip += this.view.$t('CargoMsg.Cargo_AccountPeriod') }
          if (tip) {
            const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
            if (type === 1) {
              this.view.showWarningImageB = true
              if (company && company.ifOpenSop && this.view.sopConfigOpen) {
                this.view.sopImageB = true
              }
              this.view.warningImageBTip = toolTip
            } else if (type === 2) {
              this.view.showWarningImageA = true
              this.view.warningImageATip = toolTip
            }
            checkCredit = true
          }
        }
      }
      if (!credit || !checkCredit) {
        if (company && company.ifOpenSop && this.view.sopConfigOpen) {
          if (type === 1) {
            this.view.showWarningImageB = false
            this.view.sopImageB = true
          } else if (type === 2) {
            this.view.showWarningImageA = false
            this.view.sopImageA = true
          }
        }
      }
    }
    CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  // 获取合约状态
  getContractStatus(company) {
    this.view.stampPictureView.businessDocuments = []
    if (!company) return
    Company.loadAgreementClientContract(company.uuid).then(async contracts => {
      if (contracts && contracts.length > 0) {
        const now = moment()
        const businessIds = []
        for (const item of contracts) {
          // 过滤出当前合作伙伴所有未到期的合同
          if (dateCompareYMD(item.endDate, now) >= 0) {
            businessIds.push(item.uuid)
          }
        }
        if (businessIds.length > 0) {
          findBusinessDocument({ businessIds: businessIds }).then(res => {
            const docs = res.data
            if (docs && docs.length > 0) {
              const useDocs = []
              for (const doc of docs) {
                if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                useDocs.push(doc)
              }
              this.view.stampPictureView.businessDocuments = useDocs
            }
          })
        }

        company.contractStatus = businessIds.length > 0 ? 2 : 1
      } else {
        company.contractStatus = 0 // 未签约
      }
      const contractState = this.view.contractStatuses[company.contractStatus]
      this.view.contractStatus = company.contractStatus
      this.view.contractStatusLabel = contractState ? contractState.label : ''
      this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.view.form))
    })
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
      job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.userDefinedRoleOffice1 = office ? office.officeId : 0
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
      job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.userDefinedRoleOffice2 = office ? office.officeId : 0
    }
  }
  // 自定义岗位字段
  async userDefinedRoleIdHandler(data, userDefinedRoleId, userDefinedRoleDept, userDefinedRoleOffice, role) {
    const job = this.job
    job[userDefinedRoleId] = data.value || 0
    job[userDefinedRoleDept] = 0
    job[userDefinedRoleOffice] = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', role)
      job[userDefinedRoleDept] = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job[userDefinedRoleOffice] = office ? office.officeId : 0
    }
  }
  /**
   * 提单发货地代码
   */
  changeDispatchingPlaceCode(event) {
    const job = this.job
    job.dispatchingPlaceCode = event.code
    this.changeDispatchingPlace(event.englishName, job.dispatchingPlaceCode)
  }
  /**
   * 提单发货地
   */
  changeDispatchingPlace(dispatchingPlace, dispatchingPlaceCode) {
    const job = this.job
    if (dispatchingPlace) {
      job.dispatchingPlace = dispatchingPlace
    }
  }
  /**
   * 发货人选择
   */
  async shipperChange(data) {
    const form = this.job
    form.shipperId = data.value
    const sycSCN = parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    if (form.shipperId) {
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.shipperLine1 = manifestAddress.addressLine1
        form.shipperLine2 = manifestAddress.addressLine2
        form.shipperLine3 = manifestAddress.addressLine3
        form.shipperLine4 = manifestAddress.addressLine4
        form.shipperLine5 = manifestAddress.addressLine5
        form.shipperLine6 = manifestAddress.addressLine6
        form.shipperLine7 = manifestAddress.addressLine7
      } else {
        form.shipperLine1 = ''
        form.shipperLine2 = ''
        form.shipperLine3 = ''
        form.shipperLine4 = ''
        form.shipperLine5 = ''
        form.shipperLine6 = ''
        form.shipperLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, null)
    }
  }
  /**
   * 收货人选择
   */
  async consigneeChange(data) {
    const form = this.job
    form.consigneeId = data.value
    const sycSCN = parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
    if (form.consigneeId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.consigneeLine1 = manifestAddress.addressLine1
        form.consigneeLine2 = manifestAddress.addressLine2
        form.consigneeLine3 = manifestAddress.addressLine3
        form.consigneeLine4 = manifestAddress.addressLine4
        form.consigneeLine5 = manifestAddress.addressLine5
        form.consigneeLine6 = manifestAddress.addressLine6
        form.consigneeLine7 = manifestAddress.addressLine7
      } else {
        form.consigneeLine1 = ''
        form.consigneeLine2 = ''
        form.consigneeLine3 = ''
        form.consigneeLine4 = ''
        form.consigneeLine5 = ''
        form.consigneeLine6 = ''
        form.consigneeLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, null)
    }
  }
  /**
   * 通知人选择
   */
  async notifyChange(data) {
    const form = this.job
    form.notifyId = data.value
    const sycSCN = parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
    if (form.notifyId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.notifyLine1 = manifestAddress.addressLine1
        form.notifyLine2 = manifestAddress.addressLine2
        form.notifyLine3 = manifestAddress.addressLine3
        form.notifyLine4 = manifestAddress.addressLine4
        form.notifyLine5 = manifestAddress.addressLine5
        form.notifyLine6 = manifestAddress.addressLine6
        form.notifyLine7 = manifestAddress.addressLine7
      } else {
        form.notifyLine1 = ''
        form.notifyLine2 = ''
        form.notifyLine3 = ''
        form.notifyLine4 = ''
        form.notifyLine5 = ''
        form.notifyLine6 = ''
        form.notifyLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, null)
    }
  }
  // 加载海外客服
  async loadOverseaOp() {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    let cmpIdx = 0
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      cmpIdx = job.designationAgent // 根据指定货确定海外客服
    } else {
      cmpIdx = job.destinationAgent // 还是根据目的港代理确定海外客服
    }
    if (cmpIdx > 0) {
      const cmp = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (cmp) {
        const agent = await new Company(cmp).getOverseaAgentDetail()
        if (agent) {
          const overseaAgentUsers = await new OverseaAgent(agent).getOverseaAgentUserList()
          // 海外客服
          const overseaAgentUsersList = []
          if (overseaAgentUsers && overseaAgentUsers.length > 0) {
            for (const u of overseaAgentUsers) {
              if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
                const user = this.userList.find(p => p.userId === u.userId)
                if (user && user.active) {
                  if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                    overseaAgentUsersList.push(user)
                  }
                }
              }
            }
          }
          // 海外客服
          this.view.overseaAgentUsersList = overseaAgentUsersList
        } else {
          await this.getOverseaAgentUserByConfig()
        }
      } else {
        await this.getOverseaAgentUserByConfig()
      }
    } else {
      await this.getOverseaAgentUserByConfig()
    }
  }
  async getOverseaAgentUserByConfig() {
    if (this.view.isHC) {
      return
    }
    const overseaAgentUsersConfig = parseInt(this.config.get('overseaAgentUsersConfig'))
    if (overseaAgentUsersConfig === 1 && this.view.$refs.overseaOp) {
      this.view.overseaAgentUsersList = await this.view.$refs.overseaOp.getUsersByPrivilegeDetail(`role-overseaOp--${null}-${true}`, 'role', 'overseaOp', '', null, true)
    }
  }
  /**
   * 目的港代理选择
   */
  txtDestinationAgentChangeHandler(data) {
    this.checkCreditByCompany(data.value, 'destinationAgent')
    const job = this.job
    job.destinationAgent = data.value
  }
  sopChangeBookingAgentHandler() {
  }
}
